import { allRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { communicationAuditPageConfig } from "./communicationAuditPageConfig";

export const communicationAuditRecordDefinition: RecordDefinition = {
  path: "/communication-audit",
  entityName: "g4c_communicationaudit",
  // Audits have no list of their own; they're opened from a contact.
  listRoute: "/contacts",
  backTitle: "Back to contacts",
  allowedRoles: allRoles,
  // A log entry written by the service, so nobody edits it here.
  recordEditRoles: [],
  config: communicationAuditPageConfig,
  identity: {
    titleFields: ["g4c_name"],
    fallbackTitle: "Communication Audit",
    newRecordTitle: "New Communication Audit",
  },
};
